import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userPrefDistance'
})
export class UserPrefDistancePipe implements PipeTransform {

  prefs = null;

  constructor() {
    this.prefs = JSON.parse(localStorage.getItem('currentUser')).user.prefs;
  }

  transform(value: number, args?: any): any {
    let stringValue = '';

    if (this.prefs.units_distance === null || this.prefs.units_distance === 'MLS') {
      const milesValue =  Math.round(value * 0.621371);
      stringValue += milesValue.toFixed(0);
    } else if (this.prefs.units_distance === 'KMS') {
      stringValue += value.toFixed(0) ;
    }
    return stringValue;
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_pipes/distance/user-pref-distance.pipe.ts